<template>
<nav>
    <div class="navbar swiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide">Wie hilft Vitadio?</div>
            <div class="swiper-slide">Die Patientinnen und Patienten</div>
            <div class="swiper-slide">Vitadio ergänzt</div>
            <div class="swiper-slide">Studienergebnisse</div>
            <div class="swiper-slide">App-Start</div>
            <div class="swiper-slide">Registrierung</div>
            <div class="swiper-slide">Abschluss der Registrierung</div>
            <div class="swiper-slide">Personalisierung der App</div>
            <div class="swiper-slide">Einführungsfragebogen</div>
            <div class="swiper-slide">Der erste Tag in der App</div>
            <div class="swiper-slide">Start am Morgen</div>
            <div class="swiper-slide">Live-Support</div>
            <div class="swiper-slide">Einander kennenlernen</div>
            <div class="swiper-slide">Tägliche Tipps</div>
            <div class="swiper-slide">Feedback zu den Mahlzeiten</div>
            <div class="swiper-slide">Kleine Schritte</div>
            <div class="swiper-slide">Evidenzbasierte Informationen</div>
            <div class="swiper-slide">Umsetzbares Wissen</div>
            <div class="swiper-slide">Kontinuierliche Motivation</div>
            <div class="swiper-slide">Persönlicher Support</div>
            <div class="swiper-slide">Ziele</div>
            <div class="swiper-slide">Übersichtliche Grafiken</div>
            <div class="swiper-slide">Blutzuckerwerte</div>
            <div class="swiper-slide">Community</div>
            <div class="swiper-slide">Erfolge teilen</div>
            <div class="swiper-slide">Fortschritts-Bericht</div>
            <div class="swiper-slide">Vielen Dank</div>
        </div>
        <div class="swiper-button-prev" @click="previousStep()"></div>
        <div class="swiper-button-next" @click="nextStep(true)"></div>
        <div class="fade"></div>
        <div class="fade"></div>
    </div>
</nav>
</template>

<script>
export default {
  props: {
        appStepForNavbar: {
            type: Number,
            required: true,
        }
    },

  data(){
      return {
          appStep: this.appStepForNavbar,
          numberOfSteps: 26
      }
  },

  mounted() {
    this.loadResource('/css/swiper-bundle.css', 'stylesheet')
      .then(() => {
        return this.loadResource('/js/swiper-bundle.min.js', 'script');
      })
      .then(() => {
        this.initSwiper();
      })
      .catch((error) => {
        console.log(error);
      });
  },

  watch: {
    appStepForNavbar() {
      if (this.appStep < this.appStepForNavbar) {        
        this.nextStep(false)
      }
    }
  }, 

  methods: {
    loadResource(src, type) {
      return new Promise((resolve, reject) => {
        if (type === 'stylesheet') {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = src;

          link.onload = resolve;
          link.onerror = reject;

          document.head.appendChild(link);
        } else if (type === 'script') {
          const script = document.createElement('script');
          script.src = src;

          script.onload = resolve;
          script.onerror = reject;

          document.head.appendChild(script);
        } else {
          reject(new Error('Invalid resource type'));
        }
      });
    },

    initSwiper() {
      new Swiper(".navbar", {
        slidesPerView: "auto",
        spaceBetween: 40,
        centeredSlides: true,
        simulateTouch: false,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1200: {
            spaceBetween: 70
          }
        }
      });
    },

    nextStep(notFromNavbar) {
        this.appStep++

        if (this.appStep > this.numberOfSteps) {
            this.appStep = 0
        }

        if (notFromNavbar) {          
          this.$emit('app-step-from-navbar', this.appStep)
        } else {
          const swiper = document.querySelector('.swiper').swiper;
          swiper.slideNext()
        }
    },

    previousStep() {
        this.appStep--

        if (this.appStep < 0) {
            this.appStep = this.numberOfSteps
        }

        this.$emit('app-step-from-navbar', this.appStep)
    },
  }
}
</script>

